// extracted by mini-css-extract-plugin
module.exports = {"root":"_1fE75","itemClickWrapper":"IXmQQ","imageZoomBtn":"_1pJAd","sizer":"_6toT8","imageWrapper":"_3awhv","imageBorder":"_2lbPW","image":"_1Oxdr","overlay":"_148jq"};